import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/oopbuy-spreadsheet-guide/page";
import ShippingGuidePage from "../pages/article/oopbuy-spreadsheet-shipping-guide/page";
import QCGuidePage from "../pages/article/oopbuy-spreadsheet-qc-guide/page";
import VergleichPage from "../pages/article/oopbuy-spreadsheet-vergleich/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-shipping-guide",
    element: <ShippingGuidePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-qc-guide",
    element: <QCGuidePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-vergleich",
    element: <VergleichPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;